import { Pipe, PipeTransform } from '@angular/core';
import { SigIdPaymentComponentRead } from '../../../services/sig-id.common.model';
import { toNumber } from '../../../services/helpers';

export function calcItemTotalAmount(item?: SigIdPaymentComponentRead | null): number {
  const value: number = toNumber(item?.value);
  const costs: number = toNumber(item?.costs);
  const interest: number = toNumber(item?.interest);
  return value + costs + interest;
}

@Pipe({
  name: 'itemTotalAmount',
  standalone: true,
  pure: false
})
export class ItemTotalAmountPipe implements PipeTransform {

  transform(value?: SigIdPaymentComponentRead | null): number {
    return calcItemTotalAmount(value);
  }

}
